import { render, staticRenderFns } from "./DistanceAccusationDistance.vue?vue&type=template&id=24366d64&"
import script from "./DistanceAccusationDistance.vue?vue&type=script&lang=js&"
export * from "./DistanceAccusationDistance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports